<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar v-if="route.name !== 'Support'" slot="bottom" class="pa-sm bg-white">
        <ion-tab-button class="bg-white" tab="guides" href="/home/guides">
          <ion-icon inner="true" :icon="mapOutline" />
          <ion-label>{{ t('tabs.guides') }}</ion-label>
        </ion-tab-button>
        <ion-tab-button
          v-if="user?.userType !== 'relocated' || !lastBooking"
          class="bg-white"
          tab="explore"
          href="/home/explore"
        >
          <ion-icon inner="true" :icon="locateOutline" />
          <ion-label>{{ t('tabs.explore') }}</ion-label>
        </ion-tab-button>
        <ion-tab-button class="bg-white" tab="tab2" href="/home/my-stay">
          <ion-icon inner="true" :icon="homeOutline" />
          <ion-label>{{ t('tabs.myStay') }}</ion-label>
        </ion-tab-button>
        <ion-tab-button class="bg-white" tab="support" @click="goToSupport">
          <ion-icon inner="true" :icon="chatboxOutline" />
          <ion-label>{{ t('tabs.support') }}</ion-label>
        </ion-tab-button>
        <ion-tab-button class="bg-white" tab="perks" href="/home/perks">
          <ion-icon inner="true" :icon="calendarOutline" />
          <ion-label>{{ t('tabs.perks') }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import {
    IonTabBar,
    IonTabButton,
    IonTabs,
    IonLabel,
    IonIcon,
    IonPage,
    IonRouterOutlet,
  } from '@ionic/vue';
  import { chatboxOutline, homeOutline, locateOutline, mapOutline, calendarOutline } from 'ionicons/icons';
  import { storeToRefs } from 'pinia';
  import { useAuthStore } from '@/stores/auth-store';
  import { useBookingStore } from '@/stores/booking-store';
  import { useRoute } from 'vue-router';
  import router from '@/router';

  const { user } = storeToRefs(useAuthStore());
  const { lastBooking } = storeToRefs(useBookingStore());
  const route = useRoute();

  const { t } = useI18n();

  const goToSupport = async () => {
    await router.push({ name: 'Support' });
    window.location.reload();
  };
</script>
